export function assert(expression: unknown, error = new Error('Assertion Failed')): asserts expression {
  if (!expression) throw error;
}
